export default __webpack_public_path__ + "static/media/image4-5.e1a4f3f5.png";